import { filterByUniqueKey } from '@kk/shared/utils/iterables';
import { isNullish } from '@kk/shared/utils/type-guards';
import type { Column, RowData } from '@tanstack/react-table';
import type { kkTableFeatures } from '../tableFeatures';

export interface FilterOption<TValue> {
  original: TValue;
  value: string;
}

export function getUniqueFilterOptions<TData extends RowData>(
  data: TData[],
  column: Column<typeof kkTableFeatures, TData, unknown> | undefined,
): FilterOption<unknown>[] {
  return filterByUniqueKey(
    data
      .map((row, index) => {
        const original = column?.accessorFn?.(row, index);
        const rawValue =
          typeof column?.columnDef.meta?.filterOptionValueAccessor ===
          'function'
            ? column.columnDef.meta.filterOptionValueAccessor(original)
            : original;

        if (isNullish(rawValue)) {
          return null;
        }

        return {
          original,
          value: rawValue.toString(),
        };
      })
      .filter((option): option is FilterOption<unknown> => option !== null),
    'value',
  );
}
